import _ from "lodash";

// 不同矩形布局
export function rectLayout(meshs, config) {
  let padding = config.padding;
  let row1 = 0;
  let row2 = 0;
  let row1w = 0;
  let row2w = 0;
  meshs = _.sortBy(meshs, function(mesh) {
    return -mesh.$$depth;
  });
  for (let index = 0; index < meshs.length; index++) {
    let mesh = meshs[index];
    let x;

    if (row1 > row2) {
      //取最小列
      //row2
      x = padding;
      mesh.position.z += row2 + mesh.$$depth / 2;
      mesh.position.x += mesh.$$width / 2 + padding / 2;
      mesh.$$baseline = row2 + 0.0
      row2 += mesh.$$depth + padding;
      row2w = mesh.$$width > row2w ? mesh.$$width : row2w;
    } else {
      //row1
      x = -padding;
      mesh.position.z += row1 + mesh.$$depth / 2;
      mesh.position.x -= mesh.$$width / 2 + padding / 2;
      mesh.$$baseline = row1 + 0.0
      row1 += mesh.$$depth + padding;
      row1w = mesh.$$width > row1w ? mesh.$$width : row1w;
    }
    mesh.$$x =x



    let meshr =
      mesh.position.x < mesh.position.z ? mesh.position.z : mesh.position.x;

    mesh.$$center = [mesh.position.x, 0, mesh.position.z];
    mesh.$$campoi = [
      mesh.position.x + meshr * 2,
      0 + meshr * 2,
      mesh.position.z + meshr * 2
    ];
  }

  let z = row1 > row2 ? row1 : row2;

  for (let index = 0; index < meshs.length; index++) {
    let mesh = meshs[index]
    let max = mesh.position.z + mesh.getBoundingInfo().boundingBox.maximumWorld._z - z* 0.5;
    let min = mesh.position.z + mesh.getBoundingInfo().boundingBox.minimumWorld._z - z* 0.5;
    let target = 0;
    let _z;
    if (target > max) {
      _z = max - config.padding / 2;
    } else if (target < min) {
      _z = min + config.padding / 2;
    } else {
      _z = target;
    }
    mesh.$$hotpoi = [mesh.$$x, config.table.height ,_z ];
  }

  let x = row1w + row2w + padding;
  let lookat = [0, 0, 0];
  let r = x < z ? z : x;
  let campoi = [r * .75, r /5, r * .75];
  let fences =
    1 ||
    fenceLayout(x, z, config.fence, config.fenceCorner, row1w, row2w, padding);
  return { z, x, campoi, lookat, fences };
}
//fenceCfg  宽度必须是1
export function fenceLayout(
  x,
  z,
  fenceCfg,
  fenceCornerCfg,
  row1w,
  row2w,
  padding
) {
  let xlength = Math.ceil(x) + 1;
  let zlength = Math.ceil(z) + 1;
  let xoffset = -x / 2 + row2w + padding / 2;
  let up = zlength / 2 + fenceCornerCfg.depth / 2;
  let down = -zlength / 2 - fenceCornerCfg.depth / 2;
  let left = -xlength / 2 - fenceCornerCfg.width / 2 + xoffset;
  let right = xlength / 2 + fenceCornerCfg.width / 2 + xoffset;
  let y = fenceCornerCfg.heigh / 2;
  let corner1 = {
    x: right,
    y,
    z: up,
    type: "fenceCorner",
    name: "corner1",
    r: 0
  };
  let corner2 = {
    x: left,
    y,
    z: up,
    type: "fenceCorner",
    name: "corner2",
    r: 0
  };
  let corner3 = {
    x: right,
    y,
    z: down,
    type: "fenceCorner",
    name: "corner3",
    r: 0
  };
  let corner4 = {
    x: left,
    y,
    z: down,
    type: "fenceCorner",
    name: "corner4",
    r: 0
  };
  let res = [];
  res.push(corner1);
  res.push(corner2);
  res.push(corner3);
  res.push(corner4);
  for (let i = 0; i < xlength; i++) {
    let z = up;
    let x = -xlength / 2 + fenceCfg.width * i + fenceCfg.width / 2 + xoffset;
    res.push({ x, y, z, type: "fence", name: "up" + i, r: 0 });
  }
  for (let i = 0; i < xlength; i++) {
    let z = down;
    let x = -xlength / 2 + fenceCfg.width * i + fenceCfg.width / 2 + xoffset;
    res.push({ x, y, z, type: "fence", name: "down" + i, r: Math.PI });
  }
  for (let i = 0; i < zlength; i++) {
    let z = -zlength / 2 + fenceCfg.width * i + fenceCfg.width / 2;
    let x = left;
    res.push({ x, y, z, type: "fence", name: "left" + i, r: Math.PI * 0.5 });
  }
  for (let i = 0; i < zlength; i++) {
    let z = -zlength / 2 + fenceCfg.width * i + fenceCfg.width / 2;
    let x = right;
    res.push({ x, y, z, type: "fence", name: "right" + i, r: Math.PI * 1.5 });
  }
  return res;
}

//product in 电池 布局
export function productinLayout(productcfg,producttype,config) {
  console.log(productcfg,producttype,config)
  let scal = config.scal
  let cucfg = productcfg.cu
  // {
  //   bigcu:[{
  //     start:[0,0,-1]
  //   },{
  //     start:[0,0,1]
  //   },],
  //   row:2,
  //   num:7,
  //   height:9
  // },
  // Margin Padding
  let modelMarginW = cucfg.modelMarginW
  let modelMarginH = cucfg.modelMarginH
  let cuPaddingW = cucfg.cuPaddingW
  let cuPaddingH = cucfg.cuPaddingH
  let cuMarginW = cucfg.cuMarginW
  let modelW = config.battery.width
  let modelH = config.battery.height
  let modelD = config.battery.depth
  let cuW = modelW * cucfg.row + modelMarginW*(cucfg.row-1) + cuPaddingW * 2
  let cuH = modelH * cucfg.height + modelMarginH*(cucfg.height-1) + cuPaddingH  * 2
  let cuD = modelD
  let bigcuW = cuW * cucfg.num + cuMarginW * (cucfg.num-1)
  let bigcuH = cuH
  let bigcuD = cuD
  let res = {}
  res.models = []
  res.cushot = []
  for (let i = 0; i < cucfg.bigcu.length; i++) {
    let o = cucfg.bigcu[i].start
    let r
    if(i>0){
      r = Math.PI
    }else{
      r = 0
    }
    //bigcu
    for (let j = 0; j < cucfg.num; j++) {
      let cuid = 'cu' + (i*cucfg.num + j)
      let cuX,cuY,cuZ
      cuX = o[0] + j * cuW + j * cuMarginW  +  (cucfg.row === 1?0:modelW/2)
      cuY = o[1] + cucfg.height * modelH + cucfg.height * modelMarginH + 0.2 // -1 todu
      cuZ = o[2]
      res.cushot.push({
        id:cuid,x:cuX,y:cuY,z:cuZ,index:i
      })
      //cu
      for (let k = 0; k < cucfg.height; k++) {
        //y
        for (let n = 0; n < cucfg.row; n++) {
          // model  k=0,n=0,高压模块
          let model = {}
          model.tpye = (k==0&&n==0)?'highVoltage':'battery'
          if(cucfg.row == 2){
            var _n = 1 - n
          }else{
            var _n = n
          }
          model._bigcu = i
          model.r = r
          model.producttype = producttype
          model.bigcu = producttype + '_' + i
          model.cu = model.bigcu + '_' + j
          model.id = model.cu + '_' + model.tpye+ '_' + k + '_' + n  //product + bigcu + cu + type + k + n
          let x = o[0] + j * cuW + j * cuMarginW + _n * modelW + _n * modelMarginW
          let y = o[1] + k * modelH + k * modelMarginH
          let z = o[2]
          model.poi = [x,y,z]
          model.sn = 1111
          res.models.push(model)
        }
      }
    }
  }
  console.log(res)
  return res
}



// WEBPACK FOOTER //
// ./src/components/webgl/LevelsShow/Tools/layout.js